import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ReportRecipient, ScheduleEmailParams } from '@app/interfaces/lm/report-schedules';
import { RecipientsTableComponent } from '@app/shared/components/recipients-table/recipients-table.component';
import { ReportSchedulesService } from '@services/lm/report-schedules.service';
import { ReportingService } from '@services/lm/reporting.service';
import { TaskTestCaseService } from '@services/lm/task-test-case.service';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
    selector: 'app-send-email',
    templateUrl: './send-email.component.html',
    styleUrls: ['./send-email.component.less'],
})
export class SendEmailComponent implements OnInit {
    @ViewChild('recipientsTable') recipientsTable!: RecipientsTableComponent;
    @Input() type = 'project-group';
    @Input() currentUser!: ReportRecipient;
    @Input() isProjectTestCase = false;
    isVisible = false;
    submitLoading = false;
    selectUserEmails: string[] = [];
    id!: string;

    constructor(private reportSchedulesService: ReportSchedulesService,
                private reportingService: ReportingService,
                private taskTestCaseService: TaskTestCaseService,
                private message: NzMessageService) {
    }

    ngOnInit(): void {
    }

    async open(id: string): Promise<void> {
        this.selectUserEmails = [this.currentUser.email];
        if (!id) {
            return;
        }
        this.isVisible = true;
        this.id = id;
    }

    close(): void {
        this.isVisible = false;
    }

    async submit(): Promise<void> {
        try {
            if (!this.id) {
                return;
            }
            if (!this.recipientsTable.validForm()) {
                return;
            }
            dayjs.extend(utc);
            dayjs.extend(timezone);
            const recipients = this.recipientsTable.getParams();
            this.submitLoading = true;
            if (this.type === 'test-case') {
                await this.taskTestCaseService.sendReport(this.isProjectTestCase ? {
                    recipients,
                    projectId: this.id,
                    timeZone: dayjs.tz.guess()
                } : {
                    projectGroupId: this.id,
                    recipients,
                    timeZone: dayjs.tz.guess()
                });
            } else if (this.type === 'project') {
                await this.reportingService.projectReporting({
                    recipients,
                    projectId: this.id,
                });
            } else {
                await this.reportingService.projectGroupReporting({
                    recipients,
                    projectGroupId: this.id,
                });
            }
            this.message.success('Report Email Sent Successfully');
            this.close();
        } finally {
            this.submitLoading = false;
        }
    }

    getRecipientType(): string {
        return this.type === 'test-case' ? (this.isProjectTestCase ? 'project' : 'project-group') : this.type;
    }
}


